import { render, staticRenderFns } from "./LogisticsFlowChart.vue?vue&type=template&id=4b8dbee8&scoped=true&"
import script from "./LogisticsFlowChart.vue?vue&type=script&lang=js&"
export * from "./LogisticsFlowChart.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsFlowChart.vue?vue&type=style&index=0&id=4b8dbee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8dbee8",
  null
  
)

export default component.exports